<template>

    <div id="app">

        <headerFundacion/>

        <router-view />

        <footerFundacion/>

        <!-- <veissDebug /> -->

    </div>

</template>

<script>

    import headerFundacion from '@/components/headerFundacion'
    import footerFundacion from '@/components/footerFundacion'
    // import veissDebug from '@/components/veissDebug'

    export default {
        
        components: {

            headerFundacion,
            footerFundacion,
            // veissDebug

        }

    }

</script>

<style lang="scss">
    @import 'assets/scss/layout';
    @import 'assets/scss/forms';
</style>